export default __webpack_public_path__ + "static/media/chemistry.9e7436dd.JPG";